import {IFilterFunction} from "angular";
import {PriceStrategy} from "../input/PriceStrategy";

export const PriceStrategyStrike = "tfStrategyStrike";

export function priceStrategyStrike(): IFilterFunction {
    return (value: number | null, strategy: PriceStrategy | null) => {
        if (strategy == null) {
            return value;
        } else {
            return strategy.formatStrike(value);
        }
    };
}
